// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"23dad6bd","93":"c6c9803b","108":"9c57b349","123":"d838e5cb","208":"d838e5cb","296":"d838e5cb","712":"c6c9803b","728":"c6c9803b","780":"c6c9803b","978":"cee5ae92"}[chunkId] + ".chunk.css";
};